import {RefObject, useEffect} from "react";

export function useActionOnClickingOutsideOnlyOnCondition(ref: RefObject<any>, action: Function, condition: boolean) {
    function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            action()
        }
    }

    useEffect(() => {
        if(condition) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [ref,action,condition]);
}